import React, { useEffect, useRef, useState } from "react";
import { Button, Column } from "devextreme-react/data-grid";
import { LVGridCabecera } from "../../../Componentes/Basicos/LVGridCabecera";
import { PaginaListadoMaestros } from "../../../Componentes/Compuestos/Paginas/PaginaListadoMaestros";
import ABM_ART_Articulos_Detalle from "./ABM_ART_Articulos_Detalle";
import LVButtonAgregar from "../../../Componentes/Basicos/LVButtonAgregar";
import LVButtonReporte from "../../../Componentes/Basicos/LVButtonReporte";
import { function_ABM_ART_Articulos_CargarImagenVendibleWeb, function_ABM_ART_Articulos_ListarVendibleWeb } from "neftis7_apicaller/src/funciones/ABM/ART/ABM_ART_Articulos";
import { function_base64ToHex } from "../../../funciones/Varios";

export const ABM_ART_Articulos_VendiblesWeb = () => {
  const [data, setData] = useState([])
  const refRecargaListado = useRef(null);
  const [imagenBase64, setImagenBase64] = useState(null);
  const [imagenPreview, setImagenPreview] = useState(null);

  const handleDataLoaded = (data) => {
    if (data && data.length > 0) {
      const dataConUrl = data.map(producto => {
        if (producto.Imagen) {
          let mimeType = "image/jpeg"; // por defecto
          if (producto.Imagen.startsWith("/9j/")) mimeType = "image/jpeg";
          else if (producto.Imagen.startsWith("iVBOR")) mimeType = "image/png";
          else if (producto.Imagen.startsWith("R0lGOD")) mimeType = "image/gif";

          return {
            ...producto,
            ImagenUrl: `data:${mimeType};base64,${producto.Imagen}`
          };
        } else {
          return {
            ...producto,
            ImagenUrl: null
          };
        }
      });

      setData(dataConUrl);
    } else {
      setData([]);
    }
  };

  const onClickDelete = (e) => {
    const Item = { ...e.row.data };
    if (window.confirm('¿Está seguro que desea eliminar este registro?')) {
      /*
      const setData = async () => {
        try {
          await function_ABM_ART_Articulos_Eliminar(Item.CodigoArticulo)
          refRecargaListado.current?.(); 
        } catch (error) {
          alert(error);
        }
      }
      setData();
      */
    }
  };

  const handleOnChange_Imagen = async (e, CodigoArticulo) => {
    try {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setImagenPreview(reader.result); // Vista previa
          setImagenBase64(reader.result.split(",")[1]); // Guardar solo la parte Base64
        };
        reader.readAsDataURL(file);
      }

      const logoHex = function_base64ToHex(imagenBase64);

      await function_ABM_ART_Articulos_CargarImagenVendibleWeb(CodigoArticulo, logoHex);

      alert("Imagen guardada correctamente");
    } catch (error) {
      alert("Error al guardar la Imagen");
      console.error(error);
    }
  };

  return (
    <PaginaListadoMaestros
      Titulo="ARTÍCULOS VENDIBLES WEB"
      funcion={function_ABM_ART_Articulos_ListarVendibleWeb}
      onDataLoaded={handleDataLoaded}
      refRecarga={refRecargaListado}
    >
      <div className="table-responsive">
        <div style={{ display: 'flex', alignItems: 'left', marginTop: '10px', marginBottom: '10px', gap: '20px' }}>

        </div>
        {data.length > 0 ? (
          <LVGridCabecera
            dataSource={data}
            id="gridContainer"
            keyExpr="CodigoArticulo"
            AnchoBotonera="0"
            puedeEditar={false}
            puedeImprimir={false}
            puedeMail={false}
            puedeClonar={false}
            PageSize={4}
          >
            <Column type="buttons" name="Eliminar" width={40}>
              <Button name="Eliminar" icon="trash" onClick={onClickDelete} visible={true} />
            </Column>

            <Column caption="Código" dataField="CodigoArticulo" width="120" alignment="Left" dataType="string" />
            <Column caption="Descripción" dataField="Descripcion" width="100%" minWidth="200" alignment="Left" dataType="string" />

            <Column
              caption="Imagen"
              dataField="ImagenUrl"
              width={120}
              cellRender={(cellData) => (
                cellData.value ? (
                  <img
                    src={cellData.value}
                    alt="Imagen"
                    style={{
                      width: '110px',
                      height: '110px',
                      objectFit: 'cover',
                      borderRadius: '4px'
                    }}
                  />
                ) : (
                  <span style={{ color: '#888' }}>Sin imagen</span>
                )
              )}
            />

            <Column
              caption="Imagen"
              width={70}
              alignment="center"
              allowSorting={false}
              cellRender={({ data }) => {
                let inputFileRef = null;

                return (
                  <div>
                    <button
                      title="Cargar Imagen"
                      onClick={() => {
                        inputFileRef.click(); // Dispara el click en el input oculto
                      }}
                      style={{
                        border: 'none',
                        background: 'transparent',
                        cursor: 'pointer',
                        fontSize: '1.2rem'
                      }}
                    >
                      📸
                    </button>
                    <input
                      type="file"
                      accept="image/*"
                      style={{ display: 'none' }}
                      ref={(ref) => (inputFileRef = ref)}
                      onChange={(e) => handleOnChange_Imagen(e, data.CodigoArticulo)}
                    />
                  </div>
                );

                return null;
              }}
            />

            <Column caption="Disponibilidad" alignment="Center">
              <Column caption="Lunes" dataField="LunesDisponible" width="100" alignment="Center" dataType="boolean" />
              <Column caption="Martes" dataField="MartesDisponible" width="100" alignment="Center" dataType="boolean" />
              <Column caption="Miercoles" dataField="MiercolesDisponible" width="100" alignment="Center" dataType="boolean" />
              <Column caption="Jueves" dataField="JuevesDisponible" width="100" alignment="Center" dataType="boolean" />
              <Column caption="Viernes" dataField="ViernesDisponible" width="100" alignment="Center" dataType="boolean" />
              <Column caption="Sabado" dataField="SabadoDisponible" width="100" alignment="Center" dataType="boolean" />
              <Column caption="Domingo" dataField="DomingoDisponible" width="100" alignment="Center" dataType="boolean" />
            </Column>

          </LVGridCabecera>
        ) : (
          <div className="card-body text-center">
            <h5 className="card-title">No hay datos</h5>
          </div>
        )}
      </div>
    </PaginaListadoMaestros >
  );
};
